<template>
  <div>
    <div
      class="custom-menu"
      :style="'background-color:' + config.property_data.background_color"
    >
      <div class="custom-menu-left">
        <img
          class="custom-menu-left-image"
          :src="
            config.property_data.icon_url ||
            'https://img.mockuai.com/tms/2018/1/10/upload_48dfb5b82f032311cb9207f142a95b89.png'
          "
        />
        <div
          class="custom-menu-left-title"
          :style="'color:' + config.property_data.font_color"
        >
          {{ config.link_data[0].content }}
        </div>
      </div>
    </div>
  </div>
</template>


<script>
export default {
  name: "tms-notice-board",
  props: ["config"],

  data() {
    return {};
  },

  components: {},

  mounted() {},

  methods: {},
};
</script>
<style  lang="scss" scoped>
@import "./index.scss";
</style>